export interface TimeboxEvent {
  title: string;
  description?: string;
  start: Date;
  end: Date;
}

export function defaultTimeboxStart(): Date {
  const now = new Date();
  const start = new Date(now);
  start.setMinutes(0, 0, 0);
  if (now.getMinutes() >= 30) {
    start.setHours(start.getHours() + 1);
  } else {
    start.setMinutes(30);
  }
  if (start <= now) {
    start.setTime(now.getTime() + 5 * 60 * 1000);
  }
  return start;
}

export function timeboxEnd(start: Date, minutes = 30): Date {
  return new Date(start.getTime() + minutes * 60 * 1000);
}

function formatICSDate(date: Date): string {
  return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

function formatGoogleDate(date: Date): string {
  return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

export function buildNorthStarTimeboxEvent(goalText: string, start: Date): TimeboxEvent {
  return {
    title: 'North Star timebox',
    description: `Morning Boot: work on your North Star step — ${goalText}`,
    start,
    end: timeboxEnd(start),
  };
}

export function generateICS(event: TimeboxEvent): string {
  const uid = `${Date.now()}-morning-boot@priorities.ai`;
  const dtstamp = formatICSDate(new Date());
  const dtstart = formatICSDate(event.start);
  const dtend = formatICSDate(event.end);
  const desc = (event.description ?? '').replace(/\n/g, '\\n');

  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Priorities.ai//Morning Boot//EN',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${dtstamp}`,
    `DTSTART:${dtstart}`,
    `DTEND:${dtend}`,
    `SUMMARY:${event.title}`,
    `DESCRIPTION:${desc}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
}

export function downloadICS(event: TimeboxEvent, filename = 'north-star-timebox.ics'): void {
  const blob = new Blob([generateICS(event)], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export function generateGoogleCalendarLink(event: TimeboxEvent): string {
  const params = new URLSearchParams();
  params.set('action', 'TEMPLATE');
  params.set('text', event.title);
  params.set('dates', `${formatGoogleDate(event.start)}/${formatGoogleDate(event.end)}`);
  if (event.description) params.set('details', event.description);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
